import React from "react";
import Cover from "./Cover";

// A startup's cover: its uploaded image, or the shared generated cover seeded by
// its slug so it never changes between visits.
export default function StartupCover({ s, imgClassName = "h-full w-full object-cover" }) {
  return (
    <Cover
      src={s?.cover_image_url}
      seed={s?.slug || s?.startup_id || s?.name}
      label={s?.name}
      alt={s?.name || ""}
      imgClassName={imgClassName}
      testid="startup-cover-generated"
    />
  );
}
